




































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {dateFormat} from "@/script/moment";
import store from "@/store";
import {eGameStage} from "@/common/enumData";
import moment from "moment";

@Component({
    components: {},
})
export default class VersionRow extends Vue {
    @Prop() version!: any;
    @Prop() idx!: any;

    moment = moment;
    isOpenDelete: boolean = false;

    deleteVersion(){
        this.$emit('deleteVersion', this.version)

    }

}
